import { View } from 'react-native';
import { styles } from './UserImageAreaFocusOverlay.style';
import { productPreviewTestID, userImageAreaTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { UserImageAreaFocusOverlayProps } from './UserImageAreaFocusOverlay.types';

export const UserImageAreaFocusOverlay = observer(({ userImageArea, onPress }: UserImageAreaFocusOverlayProps) => {
  const { i18n } = useStore();
  return (
    <View style={styles.gridContainer}>
      <BaseButton
        style={styles.button}
        innerStyle={styles.buttonInner}
        focusStyle={styles.buttonFocus}
        accessible={true}
        accessibilityLabel={i18n.t(`actions:edit_x`, { x: i18n.t('general:product') })}
        accessibilityRole="button"
        testID={productPreviewTestID(
          userImageArea.productId,
          undefined,
          userImageAreaTestID(userImageArea.id, TestIDs.SELECTION, '0'),
        )}
        focusId={productPreviewTestID(
          userImageArea.productId,
          undefined,
          userImageAreaTestID(userImageArea.id, TestIDs.SELECTION, '0'),
        )}
        focusOrder={0}
        focusGroup={FocusGroups.PRODUCT}
        onPress={onPress}
      >
        {() => <View style={styles.gridItem} />}
      </BaseButton>
    </View>
  );
});
